module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"h1":"Придумайте пароль","h2":"Придумайте длинный пароль из букв и цифр, который легко запомнить, но трудно угадать","enter-number":"Вернуться к вводу номера"}}')
  delete Component.options._Ctor
}
